angular.module('omfm').directive('wkColumnsManager', WkColumnsManagerDirective);

WkColumnsManagerDirective.$inject = ['$timeout'];

function WkColumnsManagerDirective($timeout) {
	return {
		restrict:    "EA",
		replace:     true,
		scope:       {
			columns: "=",
			availableTables: '=tables',
			fields: "<",
			simple: "=?",
		},
		templateUrl: "/app/omfm/templates/wkColumnsManager.html",
		link:        function ($scope, elem) {
			$scope.addCol = function(){
				$scope.columns.push({});

				$timeout(function(){
					elem.find('.filter-parts:last .select').select2();
				}, 50);
			};

			$scope.removeCol = function($index){
				let col = $scope.columns[$index];
				if((!col.table && !col.column && !col.operator && !col.value && !col.boolean) || window.confirm('Are you sure?')){
					$scope.columns.splice($index);
				}
			};
		}
	}
}